@if (currentTimezone$ | async; as currentTimezone) {
  @if (heatDates) {
    @for (heatDate of heatDates; track heatDate.name) {
      <div class="heat-date" [class.mb-1]="$index !== $count - 1">
        ({{ heatDate.name }})
        <ng-container *ngTemplateOutlet="dateTemplate; context: { displayDate: heatDate.date }"></ng-container>
      </div>
    }
  } @else {
    <ng-container *ngTemplateOutlet="dateTemplate; context: { displayDate: date }"></ng-container>
  }

  <ng-template #dateTemplate let-displayDate="displayDate">
    @if (meetDates.length > 1) {
      {{ displayDate | aliveDate: currentMeetService.meet?.timeFormat : 'ccc' : currentTimezone.activeTimezone }}
    }
    {{
      displayDate
        | aliveDate: currentMeetService.meet?.timeFormat : DateTime.TIME_SIMPLE : currentTimezone.activeTimezone
    }}
    @if (
      currentTimezone.localTechieOffset !== currentTimezone.meetTechieOffset &&
      currentTimezone.activeTimezoneLabel !== 'meet'
    ) {
      {{ displayDate | aliveDate: currentMeetService.meet?.timeFormat : 'ZZZZ' : currentTimezone.activeTimezone }}
    }
  </ng-template>
}
